import { history, InjectedCompProps, isUrl, useFile } from 'topwrite';
import path from 'path';
import { useSubBook } from '@/lib/sub-book';
import { cloneElement, useMemo } from 'react';

interface Props {
    src?: string;
}

export default function Asset({ props: { src, ...props }, children }: InjectedCompProps<Props>) {
    const subBook = useSubBook();
    const file = useFile();

    src = useMemo(() => {
        if (src && !isUrl(src)) {
            const result = subBook.validateUrl(path.join(path.dirname(history.location.pathname), src));
            if (result) {
                src = result[1];
            }
        }
        return src;
    }, [file]);

    return cloneElement(children!, {
        props: {
            ...props,
            src
        }
    });
}
